export const reasonType = 0

export const knowledgeType = 1
